const moreAboutYouConversation = {
  id: 'about-work',
  title: 'More About Me',
  messages: [
    "I specialize in building 0→1 systems that connect users to value and scale for compounding growth.",
    "",
    "That usually means working across the entire stack—from data and models to the final interface and interaction.",
    "",
    "My lens is technical: I studied Engineering at Waterloo and did a Masters in Data Science at UofT. That 'systems-first' approach shapes how I tackle every product problem.",
    "",
    "I actually tried to build those systems from scratch as an AI founder. I shipped pilots and secured LOIs, but I eventually realized I wanted to spend more time building product and less time pitching.",
    "",
    "I made the hard call to shut it down so I could go deep on product at scale.",
    "",
    "That’s what led me to Credit Karma. As the Product Lead for Discovery, I’ve focused on reversing MAU decline for 120M+ users and delivering over $200M in impact.",
    "",
    "I’m 'AI-native' by practice, so even when I’m off the clock, I’m a builder, tinkerer and vibe coder.",
    "",
    "I love being dropped into messy, ambiguous spaces, mapping the system, and then building the primitives that move the metrics that matter."
  ]
};

export default moreAboutYouConversation;

